import React from "react";
import ContactSection from "./contact_hero";
import MapComponent from "../../components/map_component";
import Footer from "../../components/footer";

const Contact = () => {
  return (
    <div>
      <ContactSection />
      <MapComponent />
      <Footer />
    </div>
  );
};

export default Contact;
